import { useReq } from "@larner.dev/use-req";
import { Box, Heading, Link } from "@chakra-ui/react";
import { Meta } from "../../../components/Meta/Meta";
import { cmsRequest } from "../../../lib/cmsHelpers";
import { useEffect } from "react";
import { LoaderScreen } from "../../../components/LoaderScreen/LoaderScreen";
import { CMSDataList, Policy as PolicyAttributes } from "@greenflagdate/shared";
import { Link as RRLink } from "react-router-dom";

export function Legal() {
  const [request, requestState] =
    useReq<CMSDataList<PolicyAttributes>>(cmsRequest);
  useEffect(() => {
    request.get("/api/policies");
  }, [request]);

  if (requestState.loading) {
    return <LoaderScreen />;
  }

  const policies = requestState.result?.data || [];

  return (
    <Box marginX="auto" maxWidth="32rem" paddingX="2rem" paddingBottom="2rem">
      <Meta>
        <title>Legal - Green Flag</title>
      </Meta>
      <Heading as="h1" textStyle="headingLg" textAlign="center" paddingY="2rem">
        Legal
      </Heading>
      <Box as="ul">
        {policies.map((p) => (
          <Box as="li" key={p.id}>
            <Link asChild color="brand.green.dark" textDecoration="underline">
              <RRLink to={`/policy/${p.attributes.slug}`}>
                {p.attributes.title}
              </RRLink>
            </Link>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
